module.exports = __webpack_public_path__ + "static/img/12.7c18273.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/12.png
// module id = NHWj
// module chunks = 0